import type { ReactNode } from "react";
import { Button } from "./Button";

interface ErrorStateProps {
  title?: string;
  message?: ReactNode;
  onRetry?: () => void;
  action?: ReactNode;
}

export function ErrorState({
  title = "Something went wrong",
  message,
  onRetry,
  action,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-danger-100 text-danger-600">
        <i className="ri-error-warning-line text-2xl" />
      </div>
      <h3 className="mt-3 text-sm font-semibold text-foreground-900">{title}</h3>
      {message ? <p className="mt-1 max-w-sm text-sm text-foreground-500">{message}</p> : null}
      {action}
      {onRetry ? (
        <Button variant="outline" size="sm" className="mt-4" icon={<i className="ri-refresh-line" />} onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </div>
  );
}